// =====================
// ハンバーガーメニュー
// =====================
$(function () {
  var syncHamburgerState = function () {
    var isOpen = $(".l-header-hamburger").hasClass("active");

    // ロゴ切り替え
    $(".l-header-logo").toggleClass("active", isOpen);

    $(".js-pagetop").toggleClass("is-menu-open", isOpen);

    $(".c-floating-menu").toggleClass("is-menu-open", isOpen);
  };

  $(".c-hamburger").on("click", function () {
    $(this).toggleClass("active");
    $(".l-header-hamburger").toggleClass("active");

    syncHamburgerState();
  });

  $(".hamburger-menu__link").on("click", function () {
    $(".c-hamburger").removeClass("active");
    $(".l-header-hamburger").removeClass("active");

    syncHamburgerState();
  });
});

$(function () {
  var $pagetop = $(".js-pagetop");
  if (!$pagetop.length) return;
  var pagetop = $pagetop[0];
  var banner = document.querySelector(".c-floating-menu");
  var spacer = document.querySelector(".c-floating-menu-spacer");
  var showAt = 300;
  var SP = 599;
  var gap = 0;

  var update = function () {
    var onBannerSP = banner && window.innerWidth <= SP;

    if (onBannerSP || window.pageYOffset > showAt) {
      $pagetop.addClass("is-visible");
    } else {
      $pagetop.removeClass("is-visible");
    }

    if (!onBannerSP) {
      pagetop.style.bottom = "";
      pagetop.style.width = "";
      pagetop.style.height = "";
      if (banner) banner.style.right = "";
      if (spacer) spacer.style.height = "";
      return;
    }

    var h = banner.getBoundingClientRect().height;
    if (h) {
      pagetop.style.width = h + "px";
      pagetop.style.height = h + "px";
      banner.style.right = h + "px";
      if (spacer) spacer.style.height = h + gap + "px";
    }
    pagetop.style.bottom = gap + "px";
  };

  $(window).on("scroll resize", update);
  update();

  $pagetop.on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 500);
  });
});

// =====================
// エリアページの追従ボタン
// =====================
$(function () {
  var banner = document.querySelector(".p-area-floating");
  var $pagetop = $(".js-pagetop");
  if (!banner || !$pagetop.length) return;

  var pagetop = $pagetop[0];
  var spacer = document.querySelector(".p-area-floating-spacer");
  var showAt = 300;

  var update = function () {
    $pagetop.toggleClass("is-visible", window.pageYOffset > showAt);

    // PCは右下、SPは全幅。どちらも追従ボタンの上にページトップを置く
    var h = banner.getBoundingClientRect().height;
    if (!h) return;
    pagetop.style.bottom = h + "px";
    if (spacer) spacer.style.height = h + "px";
  };

  $(window).on("scroll resize", update);
  update();

  $pagetop.on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 500);
  });
});

// =====================
// TOPページヘッダー色変更
// =====================
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("header");
  if (!header) return;

  const transparentHeaderPaths = [
    "/",
    "/company/request"
  ]

  // ヘッダーを透明にする対象のページかどうか判定
  const isTransparentHeaderPath = transparentHeaderPaths.includes(location.pathname);

  if (!isTransparentHeaderPath) return; // 対象外のページは何もしない

  // 初期状態で .is-transparent を付与
  header.classList.add("is-transparent");

  // ファーストビュー（.js-header-change-point があればその高さ、なければ画面高さ）
  const fvEl = document.querySelector(".js-header-change-point");
  let threshold = fvEl ? fvEl.offsetHeight : window.innerHeight;

  const update = () => {
    if (window.scrollY > threshold) {
      header.classList.remove("is-transparent");
    } else {
      header.classList.add("is-transparent");
    }
  };

  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", () => {
    threshold = fvEl ? fvEl.offsetHeight : window.innerHeight;
    update();
  });

  update(); // 初期実行
});

// =====================
// TOPヒーロー写真トランジション
// =====================
function initHeroSlider(slider) {
  slider.dataset.heroInit = 'true';

  const slides = Array.from(slider.querySelectorAll('.p-top-hero__slide'));
  const hold   = parseInt(slider.dataset.hold || '3000', 10);
  const fade   = parseInt(slider.dataset.fade || '800', 10);

  slider.style.setProperty('--hero-fade', `${fade}ms`);

  if (slides.length <= 1) return;

  let current = 0;

  function step() {
    const next = (current + 1) % slides.length;
    // 次スライドを最前面でフェードイン（旧スライドの上にクロスフェード）
    slides[next].classList.add('is-entering');
    setTimeout(() => {
      // フェード完了後に入れ替え：旧スライドを退避し、新スライドを通常activeへ
      slides[current].classList.remove('is-active');
      slides[next].classList.remove('is-entering');
      slides[next].classList.add('is-active');
      current = next;
      setTimeout(step, hold);
    }, fade);
  }

  setTimeout(step, hold);
}

function initAllHeroSliders() {
  document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
}

document.addEventListener('DOMContentLoaded', initAllHeroSliders);

// =====================
// ローディング画面
// =====================
$(window).on("load", function () {
  setTimeout(function () {
    $(".l-loading").fadeOut(1000);
  }, 1000);
});

// =====================
// メインビジュアル　キャッチコピー
// =====================
document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".p-top-hero");
  const catchEl = document.querySelector(".p-top-hero__catch");
  const nextBlock = document.querySelector(".p-top-intro"); // 停止境界（transform補正あり）
  if (!section || !catchEl || !nextBlock) return;

  // ===== 設定 =====
  const startMargin = 40; // どれだけ画面下から始めるか（px）
  const EPS = 0.5;

  // ===== util =====
  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
  const getTranslateY = (el) => {
    const t = getComputedStyle(el).transform;
    if (!t || t === "none") return 0;
    if (t.startsWith("matrix3d(")) return parseFloat(t.split(",")[13]) || 0;
    if (t.startsWith("matrix(")) return parseFloat(t.split(",")[5]) || 0;
    return 0;
  };
  const getVH = () =>
    window.visualViewport ? window.visualViewport.height : window.innerHeight;

  // ===== 幾何（毎回測る） =====
  let sectionTop = 0,
    vh = 0,
    catchH = 0;

  const measure = () => {
    sectionTop = section.getBoundingClientRect().top + window.scrollY;
    vh = getVH();
    catchH = catchEl.offsetHeight;
  };

  // .p-top-about の「素の」トップ（transform を打ち消し）
  const getNextNaturalTop = () => {
    const visualTop = nextBlock.getBoundingClientRect().top + window.scrollY;
    return visualTop - getTranslateY(nextBlock);
  };

  // 停止上限（中央基準）
  const getMaxYStop = () => {
    return Math.max(0, getNextNaturalTop() - sectionTop - catchH / 2);
  };

  // 位置関数（scrollY 依存）
  const yNatural = (sY) => sY + vh - catchH - startMargin - sectionTop; // ロック前の自然位置
  const yCenter = (sY) => sY + vh / 2 - sectionTop - catchH / 2; // 中央追従

  // ===== 状態 =====
  let state = "floor"; // 'floor' | 'locked'
  let lastScrollY = window.scrollY;

  // ===== 描画 =====
  const render = (y) => {
    // 追従の transform
    catchEl.style.transform = `translate3d(-50%, ${y}px, 0)`;

    // ★ 色切替の境界 --split を更新（.p-top-hero の下端とテキストの相対位置）
    const heroBottom = sectionTop + section.offsetHeight;
    let split = heroBottom - (sectionTop + y); // テキスト上端から見た距離
    split = clamp(split, 0, catchH);
    catchEl.style.setProperty("--split", split + "px");
  };

  // ===== メイン更新 =====
  const update = () => {
    // レイアウトの最新値を都度取得（復元スクロール/フォント/画像で変化しても追従）
    measure();
    const cap = getMaxYStop();

    const cur = window.scrollY;
    const down = cur > lastScrollY;
    const up = cur < lastScrollY;

    let y;

    if (state === "floor") {
      // ★ 初期位置を固定せず、その瞬間の自然位置で常に描画
      y = clamp(yNatural(cur), 0, cap);

      // 下方向に進み、要素中心がビューポート中央に到達したらロック
      const elemCenterViewport = sectionTop + y + catchH / 2 - cur;
      if (down && elemCenterViewport <= vh / 2 + EPS) {
        state = "locked";
      }
    } else {
      // locked
      y = clamp(yCenter(cur), 0, cap);

      // 上方向に戻り、中央追従の位置が自然位置以下になったら floor に解除
      if (up) {
        const yNat = clamp(yNatural(cur), 0, cap);
        if (y <= yNat + EPS) {
          y = yNat; // 連続性を確保
          state = "floor";
        }
      }
    }

    render(y);
    lastScrollY = cur;
  };

  // ===== 初期描画 =====
  update(); // その場の scrollY から即時計算（固定初期値なし）

  // ===== イベント =====
  let ticking = false;
  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", update, { passive: true });
  window.addEventListener("orientationchange", update, { passive: true });

  // モバイルのアドレスバー縮み等で vh が揺れる
  if (window.visualViewport) {
    visualViewport.addEventListener("resize", update, { passive: true });
    visualViewport.addEventListener("scroll", update, { passive: true });
  }

  // 画像読み込みで高さが変わる場合
  section.querySelectorAll("img").forEach((img) => {
    if (!img.complete) img.addEventListener("load", update, { once: true });
  });
  nextBlock.querySelectorAll("img")?.forEach((img) => {
    if (!img.complete) img.addEventListener("load", update, { once: true });
  });

  // Webフォント/改行/スライダーDOM変化などのレイアウト変化に強く
  try {
    const ro = new ResizeObserver(update);
    ro.observe(catchEl);
    ro.observe(section);
    ro.observe(nextBlock);
  } catch (_) {
    // 未対応ブラウザは無視
  }

  // bfcache 復帰や履歴遷移後のスクロール復元にも対応
  window.addEventListener("pageshow", update, { passive: true });
});

// =====================
// commitments　追従コンテンツ
// =====================
(() => {
  // 要素取得（このセクションの中だけを対象にする）
  const pin = document.querySelector(".p-top-commitments");
  if (!pin) return;

  const stage = pin.querySelector(".p-top-commitments__body");
  const track = pin.querySelector(".p-top-commitments__content");
  const frames = Array.from(
    pin.querySelectorAll(".p-top-commitments__content-item")
  );
  const nav = pin.querySelector(".p-top-commitments__nav");
  const navItems = nav
    ? Array.from(nav.querySelectorAll(".p-top-commitments__nav-item"))
    : [];

  if (!stage || !track || frames.length === 0) return;

  const clamp = (v, a, b) => Math.min(Math.max(v, a), b);

  // ★最後のページの滞在尺（100vh = 1）。同じ100vh滞在なら 1 のまま
  const lastHold = 1;

  let pinTop = 0,
    pinHeight = 0,
    viewportH = 0;

  // クリック中に表示を固定（途中ページのチラつき防止）
  let lockedIndex = null;

  // 計測
  function measure() {
    viewportH = window.innerHeight;
    // 総高さ = (フレーム数 + lastHold) * 100vh
    pin.style.height = (frames.length + lastHold) * viewportH + "px";

    const r = pin.getBoundingClientRect();
    pinTop = r.top + window.scrollY;
    pinHeight = pin.offsetHeight;
  }

  // iページ目の先頭スクロール位置（境界ぶれ防止で +1px）
  function pageTop(i) {
    const maxTop = pinTop + (pinHeight - viewportH) - 1; // 区間末尾の直前
    let t = pinTop + i * viewportH + 1;
    if (i === frames.length - 1) t = Math.min(t, maxTop);
    return Math.round(clamp(t, pinTop, maxTop));
  }

  // 現在ページ（0..N-1）
  function currentIndexByScroll() {
    const s = clamp(window.scrollY - pinTop, 0, pinHeight - viewportH);
    const idx = Math.floor(s / viewportH + 1e-6);
    return clamp(idx, 0, frames.length - 1);
  }

  // 表示反映（トラック移動＋ナビcurrent）
  function setCurrentIndex(i) {
    track.style.transform = `translate3d(${-i * 100}%, 0, 0)`;
    if (navItems.length) {
      navItems.forEach((el, idx) => {
        const on = idx === i;
        el.classList.toggle("current", on);
        if (on) el.setAttribute("aria-current", "page");
        else el.removeAttribute("aria-current");
      });
    }
  }

  // ナビクリック：目的ページへスクロール（表示はロック）
  function scrollToIndex(i, smooth = true) {
    i = clamp(i, 0, frames.length - 1);
    lockedIndex = i;
    setCurrentIndex(i); // 見た目を即時合わせる

    window.scrollTo({
      top: pageTop(i),
      behavior: smooth ? "smooth" : "auto",
    });
  }

  // スクロール描画
  let lastShown = -1;

  function render() {
    const idxScroll = currentIndexByScroll();

    if (lockedIndex !== null) {
      // 目的帯に入ったらロック解除
      if (idxScroll === lockedIndex) {
        lockedIndex = null;
      } else {
        // 到達前は目的ページだけ表示（途中ページは見せない）
        if (lastShown !== lockedIndex) {
          setCurrentIndex(lockedIndex);
          lastShown = lockedIndex;
        }
        return;
      }
    }

    if (idxScroll !== lastShown) {
      setCurrentIndex(idxScroll);
      lastShown = idxScroll;
    }
  }

  // イベント
  let ticking = false;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        render();
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener(
    "resize",
    () => {
      measure();
      render();
    },
    {
      passive: true,
    }
  );
  window.addEventListener("scroll", onScroll, {
    passive: true,
  });

  // ナビクリック接続（data-index が無いので“並び順のindex”を使う）
  if (navItems.length) {
    navItems.forEach((btn, idx) => {
      btn.addEventListener("click", () => scrollToIndex(idx, true));
    });
  }

  // 初期化
  measure();
  setCurrentIndex(0);
  lastShown = 0;
})();

// =====================
// splideスライダー
// =====================
document.addEventListener("DOMContentLoaded", function () {
  // =====================
  // モデルハウススライダー
  // =====================
  const mainElModel = document.querySelector(
    ".experience-slide__main--modelhouse"
  );
  const thumbElModel = document.querySelector(
    ".experience-slide__thumbnail--modelhouse"
  );

  if (mainElModel && thumbElModel) {
    const thumbs = new Splide(thumbElModel, {
      isNavigation: true,
      perPage: 3,
      gap: 8,
      focus: "center",
      pagination: false,
      arrows: false,
      rewind: true,
    });

    const main = new Splide(mainElModel, {
      type: "slide",
      perPage: 1,
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      pagination: false,
      arrows: false,
      rewind: true,
      speed: 600,
    });

    main.sync(thumbs);
    thumbs.mount();
    main.mount();

    // タイトル
    const titleEl = document.querySelector(
      ".experience-slide__title--modelhouse"
    );
    if (titleEl) {
      const updateTitle = (index) => {
        const slide = main.Components.Slides.getAt(index).slide;
        titleEl.textContent = slide.getAttribute("data-title") || "";
      };
      main.on("mounted moved", () => updateTitle(main.index));
    }

    // カウンター
    const counterEl = document.querySelector(
      ".experience-slide__counter--modelhouse"
    );
    if (counterEl) {
      const total = main.length;
      const updateCounter = (index) => {
        counterEl.textContent = `${index + 1} / ${total}`;
      };
      main.on("mounted moved", () => updateCounter(main.index));
    }

    // 外部矢印
    const prevBtn = document.querySelector(
      ".experience-slide__controls--modelhouse .splide__arrow--prev"
    );
    const nextBtn = document.querySelector(
      ".experience-slide__controls--modelhouse .splide__arrow--next"
    );
    if (prevBtn && nextBtn) {
      prevBtn.addEventListener("click", () => main.go("<"));
      nextBtn.addEventListener("click", () => main.go(">"));
    }
  }

  // =====================
  // イベントスライダー
  // =====================
  const mainElEvent = document.querySelector(".experience-slide__main--events");
  const thumbElEvent = document.querySelector(
    ".experience-slide__thumbnail--events"
  );

  if (mainElEvent && thumbElEvent) {
    const thumbs = new Splide(thumbElEvent, {
      isNavigation: true,
      perPage: 3,
      gap: 8,
      focus: "center",
      pagination: false,
      arrows: false,
      rewind: true,
    });

    const main = new Splide(mainElEvent, {
      type: "slide",
      perPage: 1,
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      pagination: false,
      arrows: false,
      rewind: true,
      speed: 600,
    });

    main.sync(thumbs);
    thumbs.mount();
    main.mount();

    // タイトル
    const titleEl = document.querySelector(".experience-slide__title--events");
    if (titleEl) {
      const updateTitle = (index) => {
        const slide = main.Components.Slides.getAt(index).slide;
        titleEl.textContent = slide.getAttribute("data-title") || "";
      };
      main.on("mounted moved", () => updateTitle(main.index));
    }

    // カウンター
    const counterEl = document.querySelector(
      ".experience-slide__counter--events"
    );
    if (counterEl) {
      const total = main.length;
      const updateCounter = (index) => {
        counterEl.textContent = `${index + 1} / ${total}`;
      };
      main.on("mounted moved", () => updateCounter(main.index));
    }

    // 外部矢印
    const prevBtn = document.querySelector(
      ".experience-slide__controls--events .splide__arrow--prev"
    );
    const nextBtn = document.querySelector(
      ".experience-slide__controls--events .splide__arrow--next"
    );
    if (prevBtn && nextBtn) {
      prevBtn.addEventListener("click", () => main.go("<"));
      nextBtn.addEventListener("click", () => main.go(">"));
    }
  }
  // =====================
  // CRAFTZEROスライダー
  // =====================
  const mainElZero = document.querySelector(".zero-slide__main");

  if (mainElZero) {
    const zeroSlider = new Splide(mainElZero, {
      type: "loop", // ループさせる
      focus: "center", // アクティブなスライドを中央に配置
      padding: "20%", // 左右のスライドのチラ見せ幅
      gap: "40px", // スライド間の余白
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      pagination: false,
      arrows: false, // デフォルトの矢印を非表示
      speed: 600,
      breakpoints: {
        599: {
          padding: "10%",
          gap: "20px",
        },
      },
    });

    // カウンターの処理
    const counterElZero = document.querySelector(".zero-slide__counter");

    if (counterElZero) {
      const updateCounter = (index) => {
        counterElZero.textContent = `${index + 1} / ${zeroSlider.length}`;
      };
      zeroSlider.on("mounted moved", () => updateCounter(zeroSlider.index));
    }

    // スライダーの初期化
    zeroSlider.mount();

    // 外部矢印ボタンの処理
    const prevBtnZero = document.querySelector(
      ".zero-slide__controls .splide__arrow--prev",
    );
    const nextBtnZero = document.querySelector(
      ".zero-slide__controls .splide__arrow--next",
    );

    if (prevBtnZero && nextBtnZero) {
      prevBtnZero.addEventListener("click", () => zeroSlider.go("<"));
      nextBtnZero.addEventListener("click", () => zeroSlider.go(">"));
    }
  }
});

// =====================
// ヘッダー背景色の自動調整（body背景色に合わせる）
// =====================
document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  const header = document.querySelector(".l-header");
  if (!body || !header) return;

  // bodyの背景色を取得
  const bodyBgColor = window.getComputedStyle(body).backgroundColor;
  
  // RGB値を取得（rgb(242, 237, 231) または rgba(...) 形式）
  const rgbMatch = bodyBgColor.match(/\d+/g);
  if (!rgbMatch || rgbMatch.length < 3) return;
  
  const r = parseInt(rgbMatch[0]);
  const g = parseInt(rgbMatch[1]);
  const b = parseInt(rgbMatch[2]);
  
  // #f2ede7 のRGB値は (242, 237, 231)
  // これ以外の場合は白背景とみなす
  const isDefaultBg = r === 242 && g === 237 && b === 231;
  
  if (!isDefaultBg) {
    body.classList.add("bg-white");
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const players = document.querySelectorAll(".js-youtube-player");
  if (!players.length) return;

  players.forEach((player) => {
    const embedUrl = player.getAttribute("data-embed-url");
    console.log(embedUrl);
    if (!embedUrl) return;

    const thumb = player.querySelector(".SalesYoutube-thumb");
    if (!thumb) return;

    const activate = () => {
      // 既に iframe 生成済みなら何もしない
      if (player.dataset.activated === "1") return;
      player.dataset.activated = "1";

      const iframe = document.createElement("iframe");
      // YouTube 標準 UI + 自動再生
      const src =
        embedUrl +
        (embedUrl.includes("?") ? "&" : "?") +
        "autoplay=1&rel=0&modestbranding=1&disablekb=1";

      iframe.src = src;
      iframe.width = "560";
      iframe.height = "315";
      iframe.frameBorder = "0";
      iframe.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
      iframe.allowFullscreen = true;

      // サムネイルを置き換え
      player.innerHTML = "";
      player.appendChild(iframe);
    };

    thumb.addEventListener("click", activate);
    thumb.addEventListener("keypress", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        activate();
      }
    });
  });
});